import { gql } from 'graphql-request';
import { getGraphQLQueryClient } from './query-client';
import { Nullable, UserWithToken, WithData } from './api.types';

type HeadingSize = 'h1' | 'h2' | 'h3' | 'h4';

type TitleItem = {
  text: string;
  size: HeadingSize;
  x: number;
  y: number;
};

type TextConfig = {
  showDate: boolean;
};

export type ImageGeneratorPreset = {
  name: string;
  titles?: TitleItem[];
  playersPosition?: { x: number; y: number };
  backgroundType?: string;
  customPositions?: number;
  textConfig?: TextConfig;
  createdAt?: string;
};

export type ImageGeneratorPresets = Record<string, ImageGeneratorPreset>;

type ImageSetting = {
  id: number;
  userId: number;
  key: string;
  value: ImageGeneratorPresets;
  createdAt: string;
  updatedAt: string;
};

const PRESETS_KEY = 'image-generator-presets';

export const getPresets = async (user: Nullable<UserWithToken>) =>
  getGraphQLQueryClient(user).request<WithData<ImageSetting | null>>(
    gql`
      query userSetting($key: String!) {
        data: userSetting(key: $key) {
          id
          userId
          key
          value
          createdAt
          updatedAt
        }
      }
    `,
    { key: PRESETS_KEY }
  );

export const savePresets = async (
  user: Nullable<UserWithToken>,
  presets: ImageGeneratorPresets
) =>
  getGraphQLQueryClient(user).request<WithData<ImageSetting>>(
    gql`
      mutation saveUserSetting($key: String!, $value: JSON!) {
        data: saveUserSetting(key: $key, value: $value) {
          id
          userId
          key
          value
          createdAt
          updatedAt
        }
      }
    `,
    { key: PRESETS_KEY, value: presets }
  );
